import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';

function EditWidgetBtn({ idLineUp = 0, lang = 'en', tz = 'CET' }) {
    return (
        <RaisedButton
            label="Edit Widget"
            onClick={() => {
                browserHistory.push({
                    pathname: '/sm/browser/post/TeamCustomSMWidget/',
                    query: { idLineUp, lang, tz, template: localStorage.getItem('C_DEFAULT_TEMPLATE') }
                });
            }}
        />
    );
}

EditWidgetBtn.propTypes = {
    // From connect
    idLineUp: PropTypes.number
};

export default connect(({ user, makerToolPage: { idLineUp } = {} }) => ({
    idLineUp,
    lang: user.props && user.props.lang,
    tz: user.props && user.props.timezone
}))(EditWidgetBtn);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/EditWidgetBtn.js
 **/